import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { hasPersistedActingOrgContext } from '~/store/profile/actingProfile.utils';
import {
  selectActingProfile,
  selectProfile,
} from '~/store/profile/profileSlice.selectors';

/**
 * Whether the signed-in user is viewing the app as an organization's Account Admin.
 *
 * Only view-as makes the acting profile differ from the user in role and organization, so that is
 * what is checked. The acting profile of a user who is not viewing as anyone is a copy of their own
 * profile, which can lag behind a refreshed one without meaning anything.
 * @returns `isActing`, true while an admin is viewing as an organization.
 */
const useActingProfile = (): { isActing: boolean } => {
  const profile = useSelector(selectProfile);
  const actingProfile = useSelector(selectActingProfile);

  const isActing = useMemo(
    () => hasPersistedActingOrgContext(profile, actingProfile),
    [profile, actingProfile]
  );

  return { isActing };
};

export default useActingProfile;
